import styled from 'styled-components';

export const EmbedCallCarouselWrapper = styled.div`
  .carousel {
    height: 45rem;
    .carousel-item {
      width: 27.3rem;
      height: 42rem;
      opacity: 1 !important;
    }
  }

  .carousel_calls_desktop {
    .nowrap {
      padding: 5rem 2.2rem;
      margin: -5rem 0;
    }

    .c4impact_card {
      transition: all linear 0.2s;
      &:hover {
        z-index: 100;
        transform: scale(1.2);
        box-shadow: 0px 3px 10px #00000050;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Embed/CallForImpact/Carousel/components/styles.js